import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { asyncScheduler } from 'rxjs';
import { AppState } from '../../core';
import { PathWaypoint } from '../../core/models';
import { PathWaypointDoc, PathWaypointService } from '../../core/services';
import { TestbedRxdbService } from '../../core/services/testbed-rxdb';
import { FesBaseComponent } from '../../shared/components/fes-base.component';

@Component({
  selector: 'app-rxdb-waypoints-edit',
  templateUrl: './rxdb-waypoints-edit.component.html',
  styleUrls: ['./rxdb-waypoints-edit.component.scss']
})
export class RxdbWaypointsEditComponent extends FesBaseComponent implements OnInit {
  
  @Input() set pathWayPoint( pathWayPoint : PathWaypointDoc ) {
    if ( pathWayPoint ) {
      this._pathWayPoint = pathWayPoint
      this.tmpPathWayPoint = { ...pathWayPoint.toJSON() }
    } 
  }
  
  _pathWayPoint : PathWaypointDoc
  tmpPathWayPoint : PathWaypoint
  
  errorMsg: string;
  bProcessing: boolean;
  
  get pathWayPoint() { return this._pathWayPoint }

  constructor(appState : AppState,
    protected pathWaypointService: PathWaypointService,
    protected rxdbService: TestbedRxdbService,
    protected editModal : BsModalRef) {
    super(appState);
  }

  ngOnInit(): void {
  }
  
  onCancel() {
    this.editModal.hide()
  }
  
  async onSave() {
    this.errorMsg = ''
    this.bProcessing = true;
    try {
      if ( this.tmpPathWayPoint._id ) {
        await this.pathWaypointService.update(this.tmpPathWayPoint).toPromise()
      }
      this.editModal.hide()
    } catch ( error ) {
      this.errorMsg = this.pathWaypointService.extractErrorMsg(error)
      this.pathWaypointService.publishError(error,this)
    } finally {
      asyncScheduler.schedule( () => this.pathWaypointService.syncNow() )
      this.bProcessing = false
    }
  }

}
